var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_908_110",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_908_110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3001 14C11.9112 14 10.539 13.6972 9.18343 13.0917C7.82787 12.4861 6.59454 11.6278 5.48342 10.5167C4.37231 9.40556 3.51398 8.17222 2.90842 6.81667C2.30287 5.46111 2.00009 4.08889 2.00009 2.7C2.00009 2.5 2.06676 2.33333 2.20009 2.2C2.33342 2.06667 2.50009 2 2.70009 2H5.40009C5.55565 2 5.69454 2.05278 5.81676 2.15833C5.93898 2.26389 6.0112 2.38889 6.03343 2.53333L6.46676 4.86667C6.48898 5.04444 6.48343 5.19444 6.45009 5.31667C6.41676 5.43889 6.35565 5.54444 6.26676 5.63333L4.65009 7.26667C4.87231 7.67778 5.1362 8.075 5.44176 8.45833C5.74731 8.84167 6.08343 9.21111 6.45009 9.56667C6.79454 9.91111 7.15565 10.2306 7.53343 10.525C7.9112 10.8194 8.3112 11.0889 8.73343 11.3333L10.3001 9.76667C10.4001 9.66667 10.5306 9.59167 10.6918 9.54167C10.8529 9.49167 11.0112 9.47778 11.1668 9.5L13.4668 9.96667C13.6223 10.0111 13.7501 10.0917 13.8501 10.2083C13.9501 10.325 14.0001 10.4556 14.0001 10.6V13.3C14.0001 13.5 13.9334 13.6667 13.8001 13.8C13.6668 13.9333 13.5001 14 13.3001 14Z",
    fill: "#36B52B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallGreen);
export default __webpack_public_path__ + "static/media/call-green.b50e71f1f93273cbeb4a96b4638b28e5.svg";
export { ForwardRef as ReactComponent };